<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <div class="timeline-container">
      <div class="timeline">
        <div
          *ngFor="let status of statusList; let i = index"
          class="timeline-item"
          [style.animation-delay]="i * 0.1 + 's'"
        >
          <div class="timeline-icon" [class.active]="isStatusComplete(status.id)">
            <svg viewBox="0 0 24 24" class="icon" [ngStyle]="{ color: getIconColor(status.id) }">
              <path [attr.d]="getIconForStatus(status.id)" fill="currentColor" />
            </svg>
          </div>
          <div class="timeline-content">
            <div class="d-flex justify-content-between">
              <div class="timeline-title">
                {{
                  isStatusComplete(status.id)
                    ? statusName(status)
                    : getNegativeStatusName(status.id)
                }}
                <span class="checkmark" *ngIf="isStatusComplete(status.id)">✓</span>
              </div>
              <div class="timeline-date" *ngIf="getStatusDate(status.id)">
                <svg viewBox="0 0 24 24">
                  <path
                    d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z"
                  />
                </svg>
                {{ getStatusDate(status.id) | date : 'dd MMM yyyy' }}
              </div>
            </div>
            <div class="timeline-details">
              {{ getStatusDetails(status, getStatusDate(status.id)) }}
            </div>
            <!-- <div class="badge">{{ getBadgeText(status.id) }}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
